import { useEffect, useState } from 'react';

/**
 * Reports whether the page has been scrolled past `threshold` pixels.
 *
 * Starts as `false` so the first render matches what a prerendered page
 * contains; the listener corrects it on mount.
 */
export const useScrolled = (threshold = 20) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
};
